import { isEmpty, isNil } from "ramda";

export default function exists(obj) {
  return !isNil(obj) && !isEmpty(obj);
}